import { useState } from 'react'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '@/common/ui/dialog'
import { Button } from '@/common/ui/button'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { useQueryClient } from '@tanstack/react-query'
import { LoginAnnouncementQueryKeys } from '@/modules/client-setting/keys'
import { GetLoginAnnouncementTableData } from '@/modules/client-setting/type'
import useMutationUpdateLoginAnnouncement from '@/modules/client-setting/api/hooks/useMutationUpdateLoginAnnouncement'
import { PencilIcon } from 'lucide-react'
import LoginAnnounceForm, {
	LoginAnnounceFormValues,
	normalizeTargetPaths,
} from '../../../LoginAnnounceForm'

interface UpdateLoginAnnounceProps {
	data: GetLoginAnnouncementTableData
}

export default function UpdateLoginAnnounce({
	data,
}: UpdateLoginAnnounceProps) {
	const [open, setOpen] = useState(false)
	const { mutate: updateLoginAnnounce } = useMutationUpdateLoginAnnouncement()
	const queryClient = useQueryClient()

	const defaultValues: LoginAnnounceFormValues = {
		title: data.title,
		type: 'content',
		content: data.content || '',
		order: data.order,
		image: data.image,
		link: data.link || '',
		linkText: data.linkText || '',
		targetPaths: (data.targetPaths ?? []).join('\n'),
	}

	const onSubmit = (formData: LoginAnnounceFormValues) => {
		const payload = {
			title: formData.title,
			content: formData.content || '',
			isActive: data.isActive,
			order: formData.order ?? undefined,
			image: formData.image,
			link: formData.link || '',
			linkText: formData.linkText || '',
			targetPaths: normalizeTargetPaths(formData.targetPaths),
		}

		updateLoginAnnounce(
			{ id: data.id, payload },
			{
				onSuccess: () => {
					toast.success('แก้ไขประกาศสำเร็จ')
					setOpen(false)
					queryClient.invalidateQueries({
						queryKey: [LoginAnnouncementQueryKeys.GetLoginAnnouncement],
					})
				},
				onError: (error) => {
					showErrorToast(error)
				},
			},
		)
	}

	return (
		<Dialog open={open} onOpenChange={setOpen}>
			<DialogTrigger asChild>
				<Button variant="ghost" size="icon">
					<PencilIcon className="size-4" />
				</Button>
			</DialogTrigger>
			<DialogContent className="sm:max-w-[800px]">
				<DialogHeader>
					<DialogTitle>แก้ไขประกาศ</DialogTitle>
				</DialogHeader>
				<LoginAnnounceForm
					defaultValues={defaultValues}
					onSubmit={onSubmit}
					submitButtonText="แก้ไขประกาศ"
					showOrder={true}
				/>
			</DialogContent>
		</Dialog>
	)
}
